import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { fadeInUpAnimation } from '../../../@fury/animations/fade-in-up.animation';
import { AuthenticationService } from '../../services/base/authentication.service';
import { Platform } from '@angular/cdk/platform';
import { Organisation } from '../../interfaces/routering/organisation';

@Component({
  selector: 'fury-survey',
  templateUrl: './download-mobile-app.component.html',
  styleUrls: ['./download-mobile-app.component.scss'],
  animations: [fadeInUpAnimation],
})
export class DownloadMobileAppComponent implements OnInit, OnDestroy {

  public isLoading: boolean = null;

  private destroy$: Subject<null> = new Subject<null>();

  constructor(private platform: Platform,
              public authenticationService: AuthenticationService,
  ) {
  }

  ngOnInit(): void {
    document.documentElement.style.setProperty('--primary-color', '#1b143c');
    document.documentElement.style.setProperty('--primary-color-text', '#ffffff');

    this.authenticationService.organisation$.subscribe((organisation: Organisation): void => {
      if (
        this.platform.IOS &&
        (typeof organisation.app_store_url !== 'undefined' && organisation.app_store_url !== null && organisation.app_store_url !== '')
      ) {
        window.location.href = organisation.app_store_url;
      }
      if (
        this.platform.ANDROID &&
        (typeof organisation.play_store_url !== 'undefined' && organisation.play_store_url !== null && organisation.play_store_url !== '')
      ) {
        window.location.href = organisation.play_store_url;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    this.isLoading = false;
  }
}
